import React from 'react';
import PropTypes from 'prop-types';
import Text from '@ux/text';

/**
 * Navigation subheading component
 *
 * @param {Object} props Props
 * @param {string} props.text Text of subheading
 * @returns {React.ReactElement} Rendered subheading
 * @private
 */
function SubHeadline({ navSubHeadline }) {
  if (navSubHeadline.text) {
    return (
      <Text.p className='nav-subheading' text={ navSubHeadline.text } />
    );
  }

  return (
    <div className='nav-subheading-custom'>{ navSubHeadline }</div>
  );
}

SubHeadline.propTypes = {
  navSubHeadline: PropTypes.oneOfType([
    PropTypes.shape({
      text: PropTypes.string
    }),
    PropTypes.node
  ]).isRequired
};

export default SubHeadline;
